import React from "react";

interface Dimensions {
    vw: number;
    vh: number;
}

const useClientDimensions = (): Dimensions => {
    const [dimensions, setDimensions] = React.useState<Dimensions>({ vw: 0, vh: 0 });

    React.useLayoutEffect(() => {
        const updateDimensions = (): void => {
            setDimensions({
                vw: window.innerWidth || 0,
                vh: window.innerHeight || 0
            });
        };

        updateDimensions();

        window.addEventListener("resize", updateDimensions);

        return () => {
            window.removeEventListener("resize", updateDimensions);
        };
    }, []);

    return dimensions;
};

export default useClientDimensions;
